import { RESET_STATE } from 'store/global/actions';

import { FREDDIE_CONNECTION_ACTION_TYPE } from '../actions';

const initialState = {
  connection: { data: null, isLoading: false, hasError: false },
  save: { isSaving: false, errorMessage: null },
};

const freddieConnectionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FREDDIE_CONNECTION_ACTION_TYPE.SET_LOADING:
      return {
        ...state,
        connection: {
          ...state.connection,
          isLoading: payload,
          hasError: payload ? false : state.connection.hasError,
        },
      };

    case FREDDIE_CONNECTION_ACTION_TYPE.SET_ERROR:
      return { ...state, connection: { ...state.connection, isLoading: false, hasError: true } };

    case FREDDIE_CONNECTION_ACTION_TYPE.GET_CONNECTION:
      return { ...state, connection: { data: payload ?? null, isLoading: false, hasError: false } };

    case FREDDIE_CONNECTION_ACTION_TYPE.SET_SAVING:
      return { ...state, save: { isSaving: payload, errorMessage: null } };

    case FREDDIE_CONNECTION_ACTION_TYPE.SET_SAVE_ERROR:
      return { ...state, save: { isSaving: false, errorMessage: payload ?? null } };

    case FREDDIE_CONNECTION_ACTION_TYPE.SAVE_CONNECTION:
      return {
        ...state,
        connection: { data: payload, isLoading: false, hasError: false },
        save: { isSaving: false, errorMessage: null },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default freddieConnectionReducer;
